import { render, staticRenderFns } from "./ExpressOrderEdit.vue?vue&type=template&id=62b80397&scoped=true"
import script from "./ExpressOrderEdit.vue?vue&type=script&lang=js"
export * from "./ExpressOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b80397",
  null
  
)

export default component.exports